import Driver from 'driver.js';
import { ref } from '@vue/composition-api';
import { biClick } from '@tencent/fit-bi-sdk';
import { i18n } from '@/i18n';
import { language } from '@tencent/ppd-base-libs';

// 是否点了下一步
const isClickStepNext = ref(false);

const lang = language.getLanguage();

function scrollTop() {
  // @ts-ignore
  document.getElementById('app').scrollTo(0, 0);
}

const driverConfig = {
  className: `home-new-guide ${lang}`,
  animate: true,
  opacity: 0.8,
  overlayClickNext: true,          // Whether the click on overlay should move next
  keyboardControl: false,            // Allow controlling through keyboard (escape to close, arrow keys to move)
  showButtons: true,
  padding: 0,                      // Distance of element from around the edges
  allowClose: false,                 // Whether the click on overlay should close or not
  nextBtnText: i18n('下一步'),
  doneBtnText: i18n('下一步'),              // Text on the final button
  closeBtnText: i18n('跳過'),            // Text on the close button for this step
  // stageBackground: 'transparent',       // Background color for the staged behind highlighted element
  // scrollIntoViewOptions: {
  //   block: 'end' as any,
  //   inline: '' as any, // 解决driver滚动问题
  // },
  onReset: () => {  // Called when overlay is about to be cleared
    if (!isClickStepNext.value) {
      biClick('new-guide.skip_click');
    }
    scrollTop();
  },
};

function setDriverAria() {
  const container = document.getElementById('driver-page-overlay');
  if (container) {
    const attrs = {
      role: 'dialog',
      tabindex: '-1',
      'aria-modal': 'true',
    };
    Object.keys(attrs).forEach((key) => {
      container.setAttribute(key, attrs[key]);
    });
    container.focus();
  }
}

function driverInit() {
  scrollTop();
  const driver = new Driver(driverConfig);
  driver.defineSteps([
    {
      element: '#driver-my-coupon-stamp',
      popover: {
        className: 'first-step-popover-class',
        title: i18n('「我的禮遇」已搬遷，更易搜尋'),
        description: '',
        position: 'top',
      },
      onNext: () => {
        biClick('new-guide.step1_click');
      },
    },
    {
      element: '#wecoupon_coupon_item_0_0',
      popover: {
        title: i18n('「首頁」就能直接領券啦'),
        description: '',
        position: 'top',
      },
      onNext: () => {
        biClick('new-guide.step2_click');
        isClickStepNext.value = true;
      },
    },
  ]);
  driver.start();
  setDriverAria();
}
export function useDriver() {
  return {
    driverInit,
  };
}
